import { apiGet, apiPatch } from './client';
import type { Source, SourceBatchRequest } from '../types/Source';

export function getSources(): Promise<Source[]> {
  return apiGet<Source[]>('/api/sources');
}

export function saveSourcesBatch(
  added: Source[],
  modified: Source[],
  deletedIds: number[],
): Promise<Source[]> {
  return apiPatch<SourceBatchRequest, Source[]>('/api/sources/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
